import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-boyd-purchase-info',
  templateUrl: './boyd-purchase-info.component.html',
  styleUrls: ['./boyd-purchase-info.component.scss'],
})
export class BoydPurchaseInfoComponent implements OnInit {

  @Input() points;
  @Input() credits;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";

  constructor(private config:ConfigService) { }

  ngOnInit() {}

}
